import React, { useEffect, useRef, useState } from 'react'
import { withRouter } from 'react-router-dom/cjs/react-router-dom.min';
import constant from '../../../../constant';
import { DeleteItemButton } from '../configMeta';

const FormBuilder = ({ state, setState, onSubmit, history, onDeleteSavedItem }) => {

    const [activeIndex, setActiveIndex] = useState(0);
    const sectionRefs = useRef([]);
    useEffect(() => {
        const handleScroll = () => {
            const offsets = sectionRefs.current.map((ref) =>
                ref ? ref.getBoundingClientRect().top : 0
            );
            const visibleIndex = offsets.findIndex((top) => top >= 0 && top < 300);
            if (visibleIndex !== -1 && visibleIndex !== activeIndex) {
                setActiveIndex(visibleIndex);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [activeIndex]);
    const onAddNewSection = () => {
        setState(prevState => [
            ...prevState,
            {
                id: '', // New section, no ID yet
                name: '',
                active: true,
                items: [{ id: '', label: '', active: true }],
            },
        ]);
    };

    const onSectionNameChange = (index, value) => {
        const updatedState = [...state];
        updatedState[index].name = value;
        setState(updatedState);
    };

    const onItemLabelChange = (sectionIndex, itemIndex, value) => {
        const updatedState = [...state];
        updatedState[sectionIndex].items[itemIndex].label = value;
        setState(updatedState);
    };

    const onAddItem = (sectionIndex) => {
        const updatedState = [...state];
        updatedState[sectionIndex].items.push({ id: '', label: '', active: true });
        setState(updatedState);
    };

    const onToggleItemActive = (sectionIndex, itemIndex) => {
        const updatedState = [...state];
        const item = updatedState[sectionIndex].items[itemIndex];

        if (item.id) {
            item.active = !item.active; // Toggle active/inactive
        } else {
            if (item.active === false) {
                item.active = true; // Undo delete for new item
            } else {
                updatedState[sectionIndex].items.splice(itemIndex, 1); // If new, just delete
            }
        }
        setState(updatedState);
    };

    // Hard delete: drop the row and, if it was saved, ask the page to send its id
    // in deletedIds. The API deactivates ids that submissions still reference.
    const onRemoveItem = (sectionIndex, itemIndex) => {
        const updatedState = [...state];
        const [removed] = updatedState[sectionIndex].items.splice(itemIndex, 1);
        if (removed?.id && onDeleteSavedItem) onDeleteSavedItem(removed.id);
        setState(updatedState);
    };

    const onToggleSectionActive = (sectionIndex) => {
        const updatedState = [...state];
        const section = updatedState[sectionIndex];

        if (section.id) {
            section.active = !section.active; // Toggle active/inactive
        } else {
            if (section.active === false) {
                section.active = true; // Undo delete for new section
            } else {
                updatedState.splice(sectionIndex, 1); // If new, just delete
            }
        }
        setState(updatedState);
    };
    return (
        <div className="row">
            <div className="col-md-3">
                <div className="scroll-left-aside">
                    <h4>Check List Form Information </h4>
                    <ul className="scroll-left-list">
                        {state
                            .filter(section => section.active !== false)
                            .map((section, index) => (
                                <li key={section.id || index}>
                                    <a href={`#section${index}`}
                                        className={activeIndex === index ? 'active' : ''}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            const target = sectionRefs.current[index];
                                            if (target) {
                                                target.scrollIntoView({ behavior: 'smooth', block: 'start' });
                                                setActiveIndex(index);
                                            }
                                        }}>
                                        <span>{String.fromCharCode(65 + index)}</span> {section.name || 'Unnamed Section'}
                                    </a>
                                </li>
                            ))}
                        <li>
                            <button type="button" className="btn btn-link" onClick={onAddNewSection}>
                                + Add New Section
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="col-md-9 ">
                <div className="appraisal-report-table-responsive">
                    <table className="assessment-table" cellSpacing={0}>
                        <tbody>
                            <tr>
                                <td className="hd-s2 pd10 w100">
                                    {" "}
                                    <p>S.No.</p>
                                </td>
                                <td className="hd-s1 pd10  w300 ">
                                    <p>ITEM DESCRIPTION</p>
                                </td>
                                {/* <td className="hd-s2 pd10">
                                    <p>REMARKS</p>
                                </td>
                                <td className="hd-s2 pd10" colSpan={2}>
                                    <p>
                                        <a name="bookmark0">‌</a>STATUS OF COMPLETION{" "}
                                        <a name="bookmark1">‌</a>
                                    </p>
                                </td> */}
                                <td className="hd-s2 pd10 w200" colSpan={2}>
                                    <p>
                                        <a name="bookmark0">‌</a>ACTION{" "}
                                        <a name="bookmark1">‌</a>
                                    </p>
                                </td>
                            </tr>
                            {/* <tr>
                                <td className="td-s1">
                                    <p className="s1" />
                                </td>
                                <td className="td-s2" />
                                <td />
                                <td className="check-td-s3 text-center">Yes</td>
                                <td className="check-td-s3 text-center">No</td>
                                <td></td>

                            </tr> */}

                            {state.map((section, sectionIndex) => (
                                <React.Fragment key={section.id || sectionIndex}>
                                    {/* Section Heading */}
                                    <tr
                                        id={`section${sectionIndex}`}
                                        ref={(el) => (sectionRefs.current[sectionIndex] = el)}>
                                        <td className="td-s1 td-s1-heading" colSpan={2}>
                                            <p className="s1">
                                                <input
                                                    type="text"
                                                    className="form-control text-center"
                                                    placeholder="Enter Section Name"
                                                    value={section.name}
                                                    onChange={(e) => onSectionNameChange(sectionIndex, e.target.value)}
                                                    disabled={section.active === false}
                                                />


                                            </p>
                                        </td>
                                        <td className='td-s1 input-new-box text-centertd-s1-heading'> <div className="d-flex align-items-center justify-content-center"><button
                                            type="button"
                                            className={`btn btn-sm btn-outline-danger ms-2 ${section.active === false ? 'btn-success' : 'btn-danger'}`}
                                            onClick={() => onToggleSectionActive(sectionIndex)}
                                        >
                                            {section.active === false ? 'Undo Delete' : 'Delete Section'}
                                        </button></div></td>
                                    </tr>

                                    {/* Items in Section */}
                                    {section.items.map((item, itemIndex) => (

                                        <tr
                                            key={item.id || itemIndex}

                                        >
                                            <td className="td-s1">
                                                <p className="s1">{itemIndex + 1}.</p>
                                            </td>
                                            {/* <td/> */}

                                            <td className="td-s2 tb-input-value">
                                                <p className="s2">
                                                    <textarea
                                                        rows={1}
                                                        className="form-control"
                                                        placeholder="Enter Item Description"
                                                        value={item.label}
                                                        onChange={(e) => onItemLabelChange(sectionIndex, itemIndex, e.target.value)}
                                                        disabled={item.active === false}
                                                    />
                                                </p>
                                            </td>
                                            {/* <td />
                                            <td className="td-form-check">
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id="formCheck1"
                                                    />
                                                </div>
                                            </td>
                                            <td className="td-form-check">
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id="formCheck1"
                                                    />
                                                </div>
                                            </td> */}
                                            <td className="td-form-check text-center w100">
                                                <button
                                                    type="button"
                                                    className={`btn btn-sm ${item.active === false ? 'btn-success' : 'btn-outline-danger'}`}
                                                    onClick={() => onToggleItemActive(sectionIndex, itemIndex)}
                                                    title={item.active === false ? 'Show this item on the form again' : 'Hide from new forms, keep on past submissions'}
                                                >
                                                    {item.active === false ? 'Activate' : 'Deactivate'}
                                                </button>
                                                <DeleteItemButton onClick={() => onRemoveItem(sectionIndex, itemIndex)} />
                                            </td>
                                        </tr>

                                        // <tr
                                        //     key={item.id || itemIndex}
                                        //     className={item.active === false ? 'bg-danger text-white' : ''}
                                        // >
                                        //     <td className="td-s1 text-center">{itemIndex + 1}.</td>
                                        //     <td className="td-s2 td-s2-input">
                                        //         <input
                                        //             type="text"
                                        //             className="form-control"
                                        //             placeholder="Enter Item Description"
                                        //             value={item.label}
                                        //             onChange={(e) => onItemLabelChange(sectionIndex, itemIndex, e.target.value)}
                                        //             disabled={item.active === false}
                                        //         />
                                        //     </td>
                                        //     <td />
                                        //     <td className="td-form-check text-center">
                                        //         <div className="form-check">
                                        //             <input type="checkbox" className="form-check-input" disabled />
                                        //         </div>
                                        //     </td>
                                        //     <td className="td-form-check text-center">
                                        //         <div className="form-check">
                                        //             <input type="checkbox" className="form-check-input" disabled />
                                        //         </div>
                                        //     </td>
                                        //     <td className="td-form-check text-center w100">
                                        //         <button
                                        //             type="button"
                                        //             className={`btn btn-sm ${item.active === false ? 'btn-success' : 'btn-outline-danger'}`}
                                        //             onClick={() => onToggleItemActive(sectionIndex, itemIndex)}
                                        //         >
                                        //             {item.active === false ? 'Undo Delete' : 'Delete Item'}
                                        //         </button>
                                        //     </td>
                                        // </tr>
                                    ))}

                                    {/* Add new Item */}
                                    {section.active !== false && (
                                        <tr>
                                            <td colSpan={6} className="text-center">
                                                <button type="button" className="btn btn-link" onClick={() => onAddItem()}>
                                                    + Add New Item
                                                </button>
                                                {/* <button
                                                    type="button"
                                                    className="btn btn-link"
                                                    onClick={() => onAddItem(sectionIndex)}
                                                >
                                                    + Add New Item
                                                </button> */}
                                            </td>
                                        </tr>
                                    )}
                                </React.Fragment>
                            ))}

                        </tbody>
                    </table>

                </div>
                <div className="row mt-4">
                    <div className="col-lg-12 text-left ">
                        <table className="table-bottom-sig">
                            <tbody>
                                <tr className="bottom-sig-tr2-box">
                                    <td className="input-td">
                                        <p className="s2">Signature of Site Manager:</p>
                                    </td>
                                    <td>
                                        <p className="s1">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder=""
                                                // defaultValue={siteManager}
                                            />
                                        </p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-lg-12 text-left ">
                        <button
                            onClick={() => { onSubmit() }}
                            type='button'
                            className="btn btn-success"
                            style={{
                                backgroundImage: "linear-gradient(90deg, #6996b5, #2b5a7e)",
                                borderColor: "#2b5a7e"
                            }}
                        >
                            Save
                        </button>
                        <button
                            type="reset"
                            className="btn btn-danger ms-3"
                            onClick={() => { history.push(constant.Authedcomponent.submitNewBuildingPreSeaTrialCheckList.url) }}
                            style={{
                                backgroundImage: "linear-gradient(90deg, #6996b5, #2b5a7e)",
                                borderColor: "#2b5a7e"
                            }}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default withRouter(FormBuilder)